import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { imageServerUrl, availableRatios, noscriptPagewidth } from './pic.settings.js';

var PreloadedImage = React.createClass({
  displayName: 'PreloadedImage',
  propTypes: {
    id: PropTypes.string.isRequired,
    version: PropTypes.string,
    ratio: PropTypes.string.isRequired,
    imageClass: PropTypes.string,
    size: PropTypes.string,
    title: PropTypes.string,
    altText: PropTypes.string,
    onPreloaded: PropTypes.func,
    source: PropTypes.string,
    imgixSettings: PropTypes.object
  },
  componentDidMount() {
    this._reportCurrentSrc(this.props.ratio);
  },
  _getWidthFromSize(size) {
    var width;
    if (size.endsWith('vw')) {
      var percent = Math.min(parseInt(size, 10), 100);
      width = noscriptPagewidth * percent / 100;
    } else {
      // pixels
      width = Math.min(parseInt(size, 10), noscriptPagewidth);
    }
    return width || 0;
  },
  _getWidthFromConfig(ratio, desiredWidth) {
    var widths = availableRatios[ratio].widths;
    var i = 0;
    var width;
    for (i; i < widths.length; ++i) {
      width = widths[i];
      if (width >= desiredWidth || i === (widths.length - 1)) {
        return width;
      }
    }
    return widths[0];
  },
  _getPreloadSrc(ratio, size, id, version, source, imgixSettings) {
    const widthFromSize = this._getWidthFromSize(size);
    const width = this._getWidthFromConfig(ratio, widthFromSize);
    return imageServerUrl({ratio, width, id, version, source, imgixSettings});
  },
  _getPreloadSrcSet(ratio, id, version, source, imgixSettings) {
    const widths = availableRatios[ratio].widths;
    const srcSet = widths.map((width) => {
      return imageServerUrl({ratio, width, id, version, source, imgixSettings}) + ' ' + width + 'w';
    }).join(', ');
    return srcSet;
  },
  _onLoad() {
    this._reportCurrentSrc();
  },
  _currentSourceReported: false,
  _reportCurrentSrc() {
    if (!this._currentSourceReported) {
      const currentSrc = ReactDOM.findDOMNode(this.refs.img).currentSrc;
      if (currentSrc) {
        this._currentSourceReported = true;
        const widthInSrc = /\/(\d+)\//.exec(currentSrc); // Expects src format: //www.svtstatic.se/image/wide/262/4444239?v=1445945377
        var width = Number(!!widthInSrc && widthInSrc[1] || 0);
        this.props.onPreloaded(this.props.ratio, width);
      }
    }
  },
  render() {
    const {imageClass, ratio, id, version, size, altText, title, source, imgixSettings} = this.props;
    const src = this._getPreloadSrc(ratio, size, id, version, source, imgixSettings);
    var srcSet;
    var sizes;
    if (size.endsWith('vw')) {
      srcSet = this._getPreloadSrcSet(ratio, id, version, source, imgixSettings);
      sizes = size;
    }
    return (
      <img
        className={"pic__img pic__img--preloaded pic__img--" + ratio + ' ' + imageClass}
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={altText}
        title={title}
        ref="img"
        onLoad={this._onLoad}
      />
    );
  }
});

export default PreloadedImage;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/Pic/_PreloadedImage.js
 **/